// extracted by mini-css-extract-plugin
export var cardWrapper = "_68-0";